import axios from 'axios';
import qs from 'qs';
import { Toast } from "vant";
import { getToken, setToken, removeToken } from "@/utils/token";
import router from "@/router";

const service = axios.create({
  baseURL: Glob.BASE_URL,
  timeout: 300000,
});

//开始 加载loading
let startLoading = () => {
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    duration: 0,
  });
}
//结束 取消loading加载
let endLoading = () => {
  Toast.clear();
}

//showFullScreenLoading() 与 tryHideFullScreenLoading() 目的是合并同一页面多个请求触发loading
let needLoadingRequestCount = 0 //声明一个变量

let showFullScreenLoading = () => {
  if (needLoadingRequestCount === 0) {
    //当等于0时证明第一次请求 这时开启loading
    startLoading();
  }
  needLoadingRequestCount++; //全局变量值++
}

let tryHideFullScreenLoading = () => {
  if (needLoadingRequestCount <= 0) {
    return; //小于等于0 证明没有开启loading 此时return
  }
  needLoadingRequestCount--; //正常响应后 全局变量 --
  if (needLoadingRequestCount === 0) {
    //等于0 时证明全部加载完毕 此时结束loading 加载
    endLoading();
  }
}

service.interceptors.request.use(
  config => {
    //加载loading
    showFullScreenLoading();
    // 设置请求头
    const token = getToken();
    // do something before request is sent
    if (token) {
      //重置token有效期
      setToken(token);
      config.headers["Authorization"] = token
      // config.headers.post['Content-Type'] = 'application/json';
    }
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
    config.transformRequest = [function (data) {
      // 在请求之前对data传参进行格式转换
      data = qs.stringify(data);
      return data
    }]
    return config;
  },
  error => {
    console.log(error)
    return Promise.reject();
  }
);

service.interceptors.response.use(
  response => {
    const res = response.data;

    if (res.code == 200) {
      //关闭loading
      tryHideFullScreenLoading();
      //返回数据
      return res.data;
    } else if (res.code == 500 || res.code == 220) {
      console.log(res);
      //关闭loading
      tryHideFullScreenLoading();
      Toast.fail({ message: res.msg, duration: 4000, });
      return Promise.reject();
    } else {
      console.log(res);
      //关闭loading
      tryHideFullScreenLoading();
      //移除本地token
      removeToken();
      //判断是否login路由
      let path = router.currentRoute.name;
      if (path == 'login' || path == '') {
        Toast.fail({ message: res.msg, duration: 4000, });
      } else {
        router.push({ name: "login", params: { errormsg: res.msg } });
      }
      return Promise.reject();
    }

  },
  error => {
    console.log(error);
    //关闭loading
    tryHideFullScreenLoading();
    Toast.fail({ message: "登陆超时，请关闭后重新打开", duration: 4000, });
    return Promise.reject();
  }
);

export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js